import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from './config';

export async function verifyAdmin() {
  const user = auth.currentUser;
  if (!user) {
    throw new Error('Non authentifié');
  }

  // Vérifier si le document admin existe
  const adminRef = doc(db, 'admin', 'status');
  const adminDoc = await getDoc(adminRef);

  // Si pas de document admin, créer le premier admin
  if (!adminDoc.exists()) {
    await setDoc(adminRef, {
      email: user.email,
      createdAt: new Date().toISOString()
    });
    return true;
  }

  // Vérifier si l'utilisateur est admin
  const adminData = adminDoc.data();
  if (adminData?.email !== user.email) {
    throw new Error('Non autorisé');
  }

  return true;
}

export async function loginWithEmail(email: string, password: string) {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  return userCredential.user;
}